import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { CreditCardDirectivesModule } from 'angular-cc-library';
import { IonicModule } from '@ionic/angular';

import { PaymentCardPage } from './payment-card.page';
import { CreditCardService } from '../services/credit-card.service';

const routes: Routes = [
  {
    path: '',
    component: PaymentCardPage,
  },
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    RouterModule.forChild(routes),
    CreditCardDirectivesModule,
  ],
  declarations: [PaymentCardPage],
  providers: [CreditCardService],
})
export class PaymentCardPageModule {}
